import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Dropdown} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import {startsWith} from '../../../../common/util/dropdown';

class PriceFactorsGroupSelector extends Component {
  componentDidMount() {
    this.props.fetchPriceFactorsGroups();
  }
  parseGroups(groups = []) {
    return groups.map((item) => ({'text': item?.tdeGroup ? item.tdeGroup : '',
      'value': item?.tdeGroup ? item.tdeGroup : ''}));
  }

  render() {
    const {value, name, priceFactorsGroups, priceFactorsGroupsLoading, changeValue} = this.props;

    return (
      <Dropdown selection fluid
        name={name}
        search={startsWith}
        value={value}
        loading={priceFactorsGroupsLoading}
        disabled={priceFactorsGroupsLoading}
        options={this.parseGroups(priceFactorsGroups)}
        onChange={changeValue}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'priceFactorsGroupsLoading': state.priceFactorsGroups.loading,
    'priceFactorsGroups': state.priceFactorsGroups.list,
  };
};

const {fetchPriceFactorsGroups} = Actions;

export default connect(mapStateToProps, {fetchPriceFactorsGroups})(PriceFactorsGroupSelector);
